import { VChip } from 'vuetify/lib/components/VChip';
import { VChipGroup } from 'vuetify/lib/components/VChipGroup';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "d-flex flex-column gr-6",
      class: { "px-4 mt-4": _setup.isMobile },
    },
    [
      _c(
        "div",
        {
          staticClass: "text--text",
          class: _setup.isMobile ? "text-h6" : "text-h5",
        },
        [
          _vm._v(
            "\n    " +
              _vm._s(
                _setup.t(
                  "Клиники и врачи, которые заказывали отзывы",
                  _setup.options
                )
              ) +
              "\n  "
          ),
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "d-flex flex-column gr-3" }, [
        _c("div", { staticClass: "text-body-1 text--text" }, [
          _vm._v(
            "\n      " +
              _vm._s(
                _setup.t(
                  "Заблокировали им любые возможности для продвижения на портале и обнулили их рейтинг.",
                  _setup.options
                )
              ) +
              "\n      " +
              _vm._s(
                _setup.t(
                  "На их странице пациенты увидят предупреждающий баннер.",
                  _setup.options
                )
              ) +
              "\n    "
          ),
        ]),
        _vm._v(" "),
        _c(
          "a",
          {
            staticClass: "text-body-1 primary--text link-decoration-none",
            attrs: { href: _setup.reverseFull({ name: "rate_fraud_free" }) },
          },
          [
            _vm._v(
              "\n      " +
                _vm._s(
                  _setup.t(
                    "Условия программы «Отзывы без обмана»",
                    _setup.options
                  )
                ) +
                "\n    "
            ),
          ]
        ),
      ]),
      _vm._v(" "),
      _c(
        VChipGroup,
        {
          attrs: {
            mandatory: "",
            color: "primary",
            "active-class": "border-primary",
          },
          model: {
            value: _setup.tab,
            callback: function ($$v) {
              _setup.tab = $$v
            },
            expression: "tab",
          },
        },
        [
          _c(VChip, { attrs: { value: "lpu", outlined: "" } }, [
            _vm._v(
              "\n      " +
                _vm._s(_setup.t("Клиники", _setup.options)) +
                " " +
                _vm._s(_setup.lpus.length) +
                "\n    "
            ),
          ]),
          _vm._v(" "),
          _c(VChip, { attrs: { value: "doctor", outlined: "" } }, [
            _vm._v(
              "\n      " +
                _vm._s(_setup.t("Врачи", _setup.options)) +
                " " +
                _vm._s(_setup.doctors.length) +
                "\n    "
            ),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "keep-alive",
        [
          _setup.tab === "lpu"
            ? _c(_setup.LpuCards, {
                staticClass: "shame-mark__grid",
                attrs: { lpus: _setup.lpus },
              })
            : _c(_setup.DoctorCards, {
                staticClass: "shame-mark__grid",
                attrs: { doctors: _setup.doctors },
              }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }